export const SET_CURRENT_ORG = "SET_CURRENT_ORG";
export const SET_BASIC_NLP_TAB = "SET_BASIC_NLP_TAB";

type UIStateAction = typeof SET_CURRENT_ORG | typeof SET_BASIC_NLP_TAB;

export interface UIStatePayload {
  type: UIStateAction;
  data: any;
}
